export * from './Waste';
export { default } from './Waste';
